import { gql } from "@/services/httpAdapter";

export const onCreateTemporaryGuaranteedSetup = gql`
	subscription onCreateTemporaryGuaranteedSetup($_id: String) {
		onCreateTemporaryGuaranteedSetup(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;

export const onDeleteTemporaryGuaranteedSetup = gql`
	subscription onDeleteTemporaryGuaranteedSetup($_id: String) {
		onDeleteTemporaryGuaranteedSetup(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;

export const onUpdateTemporaryGuaranteedSetup = gql`
	subscription onUpdateTemporaryGuaranteedSetup($_id: String) {
		onUpdateTemporaryGuaranteedSetup(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;

export const onCreateTemporaryGuaranteedItem = gql`
	subscription onCreateTemporaryGuaranteedItem($_id: String) {
		onCreateTemporaryGuaranteedItem(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;

export const onUpdateTemporaryGuaranteedItem = gql`
	subscription onUpdateTemporaryGuaranteedItem($_id: String) {
		onUpdateTemporaryGuaranteedItem(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;

export const onDeleteTemporaryGuaranteedItem = gql`
	subscription onDeleteTemporaryGuaranteedItem($_id: String) {
		onDeleteTemporaryGuaranteedItem(_id: $_id) {
			_id
			title
			itemsCount
			effectiveDateFrom
			effectiveDateTo
			createdOn
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
			createdBy {
				_id
				fullName
			}
			items {
				_id
				entryDate
				addedBy {
					_id
					fullName
				}
				nameAssociate {
					_id
					fullName
					position
				}
				effectiveDateFromItem
				effectiveDateToItem
				amount
				updatedAt
				payoutFrequency
			}
		}
	}
`;
